// extracted by mini-css-extract-plugin
export var childrenContainer = "_4v-0";
export var virtualScrollArea = "_4v-1";